import { FragmentRemoteComponentBase } from "@constructor/federation-common/react";
import React, { useContext, useMemo } from "react";
import { f as fragmentContext } from "./inject.js";
function FragmentRemoteComponent(options) {
  const context = useContext(fragmentContext);
  const fragment = useMemo(() => {
    const fragmentMemo = context.inject("subfragments").createFragment(options.remote);
    if (!fragmentMemo) {
      throw new Error("Neither federationRoot nor fragmentContext are provided");
    }
    return fragmentMemo;
  }, [context, options.remote]);
  return /* @__PURE__ */ React.createElement(FragmentRemoteComponentBase, { ...options, fragment });
}
export {
  FragmentRemoteComponent as F
};
//# sourceMappingURL=FragmentRemoteComponentx.js.map
